import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { TeamLogoComponent } from './components/team-logo.component';
import { UpdateProfileModule } from '@athlete-x/forms/update-profile/update-profile.module';
import { SharedModule } from '@athlete-x/shared';

@NgModule({
    declarations: [
        TeamLogoComponent
    ],
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        UpdateProfileModule,
        SharedModule
    ],
    exports: [
        TeamLogoComponent
    ]
})
export class TeamLogoModule {
}
